import { gql, GraphQLClient } from "graphql-request";
import { createGraphqlClient, type GraphqlRequestConfig } from "./client";

// GraphQL Mutation
const MARK_LESSON_COMPLETE_MUTATION = gql`
  mutation MarkLessonComplete($input: MarkLessonCompleteInput!) {
    markLessonComplete(input: $input) {
      success
      message
      completedLessons
      totalLessons
      progressPercentage
      completedCourse
      courseName
      xp
      totalXp
      rank
      rankUp
      previousRank
      level
      levelUp
      previousLevel
    }
  }
`;

// Types
export interface MarkLessonCompleteInput {
  lessonId: string;
  courseId: string;
}

export interface LessonCompletionResponse {
  success: boolean;
  message: string | null;
  completedLessons: number;
  totalLessons: number;
  progressPercentage: number;
  completedCourse: boolean;
  courseName: string | null;
  xp: number;
  totalXp: number;
  rank: string | null;
  rankUp: boolean;
  previousRank: string | null;
  level: number;
  levelUp: boolean;
  previousLevel: number | null;
}

export interface GraphqlLessonCompletionOptions extends GraphqlRequestConfig {
  client?: GraphQLClient;
}

function ensureClient(options?: GraphqlLessonCompletionOptions) {
  if (options?.client) {
    return options.client;
  }
  return createGraphqlClient(options);
}

/**
 * レッスンを完了としてマークする
 */
export async function markLessonComplete(
  input: MarkLessonCompleteInput,
  options?: GraphqlLessonCompletionOptions
): Promise<LessonCompletionResponse> {
  const client = ensureClient(options);
  const data = await client.request(MARK_LESSON_COMPLETE_MUTATION, { input });
  return (data as any).markLessonComplete;
}
